export enum ProcedureMapEnum {
	FixedRestorativeGlidewellIo = 32,
	ImplantPlanningDefaultNoSendTo = 65
}
